import { FormView } from '../account/form-view';
import firebase from "firebase/app";
import "firebase/auth";

export default FormView.extend({

    initialize: function(opts) {
        FormView.prototype.initialize.apply(this, [opts]);
        this.oldPassword = this.el.querySelector("#oldPassword");
        this.oldPassword.value = "";
    },

    executeOperation: function() {
        let newPassword = this.el.querySelector("#newPassword");
        let newPasswordConfirm = this.el.querySelector("#newPasswordConfirm");

        return new Promise((resolve, reject) => {

            if (newPassword.value !== newPasswordConfirm.value) {
                reject(getI18N(jlocale.confirmPasswordMismatch));
            }

            const authUser = firebase.auth().currentUser;
            const credentials = firebase.auth.EmailAuthProvider
                .credential(authUser.email, this.oldPassword.value);

            authUser.reauthenticateWithCredential(credentials)
                .then(() => authUser.updatePassword(newPassword.value))
                .then(() => {
                    this.oldPassword.value = '';
                    newPassword.value = '';
                    newPasswordConfirm.value = '';
                    resolve();
                 })
                .catch((error) => {
                    if (error.code === "auth/wrong-password") {
                        reject(getI18N(jlocale.wrongpassword));
                    } else if (error.code === "auth/weak-password") {
                        reject(getI18N(jlocale.passwdLengthError));
                    } else {
                        reject(getI18N(jlocale.error));
                    }
                });
        });
    }
})